import {
  AfterFanoutTransformationExampleRows,
  AfterMapObjectTransformationExampleRows
} from "./constants/transformationInputOutput";
import { DestinationSelectInputField } from "@/components/custom/InputField/WorkflowSelectInput";
import { CampArrayFieldOptions } from "@/constants/workflows/workflowCreate";
import { forwardRef, useImperativeHandle, useState } from "react";
import { FanoutProps, FanoutRef } from "./types/fanout";

export const Fanout = forwardRef<FanoutRef, FanoutProps>(({ initialConfiguration }, ref) => {
  const [fanoutOn, setFanoutOn] = useState<string>(initialConfiguration?.fanoutOn || "");
  const [error, setError] = useState<boolean>(false);

  useImperativeHandle(ref, () => ({
    validate: () => {
      const hasError = !fanoutOn.trim();
      setError(hasError);
      return !hasError;
    },
    getData: () => {
      return {
        fanoutOn
      };
    }
  }));

  return (
    <div className="text-primary flex flex-col max-h-[500px] min-h-[300px] h-full">
      <div className="flex-1 overflow-y-auto thin-scrollbar pr-2">
        <div className="flex w-full mb-4">
          <div className="w-1/2 flex-col items-start">
            <p className="text-sm font-medium">
              Example original rows
            </p>
            <div className="bg-foreground rounded-md border p-4 mt-1 max-h-[250px] overflow-auto thin-scrollbar">
              <pre className="text-xs">
                {JSON.stringify(AfterMapObjectTransformationExampleRows, null, 2)}
              </pre>
            </div>
          </div>
          <div className="mx-1" />
          <div className="w-1/2">
            <p className="text-sm font-medium">Transformed rows after fanout on parents fields</p>
            <div className="bg-foreground rounded-md border p-4 mt-1 max-h-[250px] overflow-auto thin-scrollbar">
              <pre className="text-xs">
                {JSON.stringify(AfterFanoutTransformationExampleRows, null, 2)}
              </pre>
            </div>
          </div>
        </div>
        <div className="w-2/3 max-w-[280px]">
          <DestinationSelectInputField
            label="Select a field to fanout on"
            value={fanoutOn}
            selectOptions={CampArrayFieldOptions}
            onChange={(value) => {
              setFanoutOn(value);
              setError(false);
            }}
            additionalClassName="bg-foreground"
            hasError={error}
          />
          {error && (
            <p className="text-destructive text-xs mt-1">Fanout field is required</p>
          )}
        </div>
      </div>
    </div>
  )
});
